const ru = {
  title: `Как пользоваться`,
  subTitle: '(UXCG - Находим решения ваших проблем)',
  description: `UXCG — это бесплатный инструмент, который помогает разобраться в самых популярных проблемах продуктового и проектного менеджмента с точки зрения когнитивной науки и поведенческой экономики.`,
  defaultStage: 'Сбор команды',
  selectStageTxt: 'Выберите стадию вашего проекта',
  relevantQuestionsTxt: 'Актуальные вопросы для вашего проекта',
};

export default ru;
